import { ComponentPropsWithoutRef } from 'react';

import type { IconProps as Props } from './types';

export const IconPersonExperience = (props: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg width="20px" height="20px" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.4 3.6a2.4 2.4 0 1 0 0 4.8 2.4 2.4 0 0 0 0-4.8Zm-2.828-.428a4 4 0 1 1 5.656 5.656 4 4 0 0 1-5.656-5.656Zm-1.697 9.502A6.4 6.4 0 0 1 16.8 17.2a.8.8 0 0 1-.8.8H4.8a.8.8 0 0 1-.8-.8 6.4 6.4 0 0 1 1.875-4.525ZM10.4 12.4a4.8 4.8 0 0 0-4.733 4h9.466a4.8 4.8 0 0 0-4.733-4Z"
        fill="#E10A0A"
      />
    </svg>
  );
};

export const IconPersonExperienceNew = ({
  className,
  width = '48',
  height = '48',
  stroke = 'currentColor',
  strokeWidth = '2.5',
  fill = 'none',
  ...props
}: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M33.4287 13.8333C33.4287 18.988 29.2073 23.1667 24.0001 23.1667C18.7928 23.1667 14.5715 18.988 14.5715 13.8333C14.5715 8.67867 18.7928 4.5 24.0001 4.5C29.2073 4.5 33.4287 8.67867 33.4287 13.8333Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 27.1666C14.8873 27.1666 7.5 34.4793 7.5 43.5H40.5C40.5 34.4793 33.1127 27.1666 24 27.1666Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
